<template>
  <div class="top-tab">
    <div
      class="item"
      v-for="(page, index) in pageList"
      :key="page.id"
      @click="changePage(index)"
      :class="{ active: index === currentPage }"
    >
      <span>{{ page.title }}</span>
      <!-- 仅保留 stop 阻止冒泡，移除 self 避免点击失效 -->
      <i
        class="close el-icon-close"
        title="关闭"
        @click.stop="closePage(index, page)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageList: {
      type: Array,
      default: () => [],
    },
    // 可选：接收当前激活下标，用于高亮激活标签
    currentPage: {
      type: Number,
      default: -1,
    },
  },
  methods: {
    changePage(index) {
      this.$emit("change", index);
    },
    closePage(index, page) {
      console.log(`${page.name}`, "关闭的是什么值");
      sessionStorage.removeItem(`${page.name}`);
      // 修复：事件名改为短横线形式，匹配父组件的 @close-page
      this.$emit("close-page", index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./TopTab";
</style>